export const CONSENT_COOKIE_NAME = 'hdph_consent';

export type CookieConsentValue = 'accepted' | 'declined';

const CONSENT_CHANGED_EVENT = 'hdph-consent-changed';

function consentCookieSuffix(): string {
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
    return `; max-age=31536000; path=/; SameSite=Lax${secure}`;
}

/** Reads `hdph_consent` using the same rules as legacy `main.js`. */
export function getCookieConsent(): CookieConsentValue | null {
    if (typeof document === 'undefined') {
        return null;
    }
    const hasAccepted = document.cookie.split(';').some(c => c.trim() === `${CONSENT_COOKIE_NAME}=1`);
    if (hasAccepted) {
        return 'accepted';
    }
    const hasDeclined = document.cookie.split(';').some(c => c.trim() === `${CONSENT_COOKIE_NAME}=0`);
    if (hasDeclined) {
        return 'declined';
    }
    return null;
}

export function hasCookieConsentDecision(): boolean {
    return getCookieConsent() !== null;
}

export function isThirdPartyConsentGranted(): boolean {
    return getCookieConsent() === 'accepted';
}

function writeConsentCookie(value: '1' | '0' | ''): void {
    if (value === '') {
        document.cookie = `${CONSENT_COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax${
            window.location.protocol === 'https:' ? '; Secure' : ''
        }`;
    } else {
        document.cookie = `${CONSENT_COOKIE_NAME}=${value}${consentCookieSuffix()}`;
    }
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT));
}

export function setCookieConsentAccepted(): void {
    writeConsentCookie('1');
}

export function setCookieConsentDeclined(): void {
    writeConsentCookie('0');
}

/** Clears consent so the banner can be shown again (legacy `hd.cookieManage`). */
export function resetCookieConsent(): void {
    writeConsentCookie('');
}

export function subscribeCookieConsentChanged(listener: () => void): () => void {
    window.addEventListener(CONSENT_CHANGED_EVENT, listener);
    return () => {
        window.removeEventListener(CONSENT_CHANGED_EVENT, listener);
    };
}
